module.exports = {
  ACCESS: {
    CLEARANCE: 'CLEARANCE',
    LOBBY: 'LOBBY',
    PROTECTED: 'PROTECTED'
  },
  ACTION: {
    BULK_PROVISION: 'bulkProvision',
    EMAIL_CONFIRMATION: 'emailConfirmation',
    ISSUER: 'issuer',
    MANAGE: 'manage',
    REGISTER: 'register'
  },
  ACTION_SHEET: {
    CONFIRM_COUNTRY: 'locale-action-sheet-confirm-country',
    CONFIRM_COUNTRY_AND_LANGUAGE: 'locale-action-sheet-confirm-country-and-language',
    CONFIRM_LANGUAGE: 'locale-action-sheet-confirm-language',
    DISPLAY_LOCALE: 'locale-action-sheet-display-locale',
    SELECT_COUNTRY: 'locale-action-sheet-select-country',
    SELECT_LANGUAGE: 'locale-action-sheet-select-language',
    SELECT_LANGUAGE_UNSUPPORTED: 'locale-action-sheet-select-language-unsupported'
  },
  ADDRESS_FORMAT: {
    FULL: 'FULL',
    NONE: 'NONE',
    POSTAL_CODE: 'POSTAL_CODE'
  },
  ANALYTICS: {
    ERROR: 'Error',
    EVENTS: {
      ADD_BILLING_ADDRESS: 'Click - Button - Add Billing Address',
      ADD_CARD_BUTTON: 'Click - Button - Add Mastercard',
      ADD_SHIPPING_BUTTON: 'Click - Button - Add Shipping Address',
      BROWSER_EXCHANGE_ERROR: 'Browser Exchange Error',
      CANCEL_BUTTON: 'Click - Button - Cancel',
      CARD_SELECT_CLICK: 'Click - Card - Change',
      CHANGE_LANGUAGE_CONFIRM: 'Click - Button - Change Language - Confirm',
      CHANGE_LOCALE_CONFIRM: 'Click - Button - Change Locale - Confirm',
      CHANGE_LOCALE_DISMISS: 'Click - Button - Change Locale - Dismiss',
      CHANGE_THEME: 'Click - Radio - Change Theme',
      CLOSE_BUTTON: 'Click - Button - Close',
      CONTINUE_BUTTON: 'Click - Button - Continue',
      COOKIE_CONSENT_BUTTON: 'Click - Button - Cookie Consent',
      COPY_SESSION_ID_BUTTON: 'Click - Button - Copy Session ID',
      COPYRIGHT_BUTTON: 'Click - Button - Copyright Notice',
      DELETE_BUTTON: 'Click - Button - Delete',
      EDIT_BILLING_ADDRESS: 'Click - Button - Edit Billing Address',
      FAQ_OPENED: 'faq-opened',
      FAQ_CLOSED: 'faq-closed',
      FORGET_CARD_BUTTON: 'Click - Button - Forget This Card',
      FREQUENTLY_ASKED_QUESTIONS: 'Click - Button - Route from Home to FAQ',
      FREQUENTLY_ASKED_QUESTIONS_SUPPORT: 'Click - Button - Support - Frequently Asked Questions',
      SUPPORT: 'Click - Button - Support',
      GO_BACK_BUTTON: 'Click - Button - Go back',
      LANGUAGE_SETTINGS: 'Click - Button - Language Settings',
      MANAGE_SETTINGS: 'Click - Button - Manage Settings',
      MERCHANT_LOGO_CLICK: 'Click - Logo - Merchant Logo',
      MODAL_CANCEL_BUTTON: 'Click - Button - Cancel on Modal',
      MODAL_CONTINUE_BUTTON: 'Click - Button - Continue on Modal',
      MODAL_DELETE_BUTTON: 'Click - Button - Delete on Modal',
      OK_BUTTON: 'Click - Button - OK',
      OTP_SUBMISSION: 'Consumer Verify - Submit OTP Button',
      PAGE_LOAD: 'Page Load',
      RESEND_CODE_BUTTON: 'Click - Button - Resend Code',
      RESEND_OTP_EMAIL: 'Consumer Method - Resend OTP to Email Button',
      RESEND_OTP_SMS: 'Consumer Method - Resend OTP to SMS Button',
      SAVE_BUTTON: 'Click - Button - Save',
      SHIP_TO_BILLING_ADDRESS: 'Click - Button - Ship to this Address',
      SIGN_IN: 'Click - Button - Sign In',
      TERMS_BUTTON: 'Click - Button - Terms',
      VIEW_ALL_CARDS: 'Click - Button - View All Cards'
    },
    FAIL: 'Fail',
    FEATURES: {
      BULK_PROVISIONING: 'bulk',
      DEFAULT: 'default'
    },
    FLOW: {
      ACCOUNT_MANAGE: 'Account Management - Login',
      ACCOUNT_REGISTRATION: 'Account Management - Registration'
    },
    PASS: 'Pass'
  },
  BULK: {
    PROVISIONED: 'PROVISIONED',
    RETRY_LIMIT: 3,
    UNPROVISIONED: 'UNPROVISIONED'
  },
  CARD_DATA: {
    PENDING_SCA: 'PENDING_SCA'
  },
  CARD_STATUS: {
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    PENDING: 'PENDING',
    SUSPENDED: 'SUSPENDED'
  },
  CLIENT_ID: 'e0c3be1a-fcb2-11ea-adc1-0242ac120002',
  COMPLIANCE_PRIVACY_URL:
    'https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html',
  COMPLIANCE_PRIVACY_URL_FRENCH_CANADA:
    'https://www.mastercard.com/global/cliquer-pour-payer/country-listing/privacy.html',
  COMPLIANCE_TERMS_URL: 'https://www.mastercard.com/global/click-to-pay/country-listing/terms.html',
  COMPLIANCE_TERMS_URL_FRENCH_CANADA:
    'https://www.mastercard.com/global/cliquer-pour-payer/country-listing/terms.html',
  COUNTRY_FEATURES: {
    DISABLE_FEEDBACK: 'DISABLE_FEEDBACK',
    ENABLE_ADDRESS_AUTOCOMPLETE: 'ENABLE_ADDRESS_AUTOCOMPLETE',
    EXPLICIT_TERMS_CONSENT: 'EXPLICIT_TERMS_CONSENT'
  },
  DATA_TEST: {
    ERROR: 'error-page'
  },
  DEFAULT_APP_INSTANCES_LIMIT: 10,
  DCF: 'dcf',
  DEFAULT_LANGUAGE: 'en',
  ERROR_SOURCE: {
    BILLING_ADDRESS: 'billingAddress',
    NATIONAL_ID: 'nationalIdentifier'
  },
  FEATURES: {},
  IDENTITY_TYPE: {
    EMAIL: 'EMAIL',
    SMS: 'SMS'
  },
  KPI: {
    OPERATION: {
      PAGE_LOAD: 'PAGE_LOAD'
    },
    RESOURCE: {
      IDV_AUTHENTICATION_SCREEN: 'IDV_AUTHENTICATION_SCREEN'
    },
    STATE: {
      COMPLETED: 'COMPLETED'
    }
  },
  LOADERS: {
    ADD_PAYMENT: {
      heading: 'processing.addPayment',
      id: 'ADD_PAYMENT'
    },
    APP_INIT: {
      id: 'APP_INIT'
    },
    DELETE_PROFILE: {
      heading: 'processing.deleteProfile',
      id: 'DELETE_PROFILE'
    },
    RESEND_CODE: {
      heading: 'processing.resendCode',
      id: 'RESEND_CODE'
    },
    UPDATE_PROFILE: {
      heading: 'processing.updatingProfile',
      id: 'UPDATE_PROFILE'
    },
    VERIFY_DETAILS: {
      heading: 'processing.verifyingDetails',
      id: 'VERIFY_DETAILS'
    }
  },
  NETWORK: {
    MAESTRO: 'maestro',
    MASTERCARD: 'mastercard'
  },
  PRIVACY_URL_FRENCH_CANADA:
    'https://www.mastercard.com/global/cliquer-pour-payer/fr-ca/privacy-notice.html',
  PROMOTIONAL_MERCHANTS: {
    PRICELESS_PLANET: 'priceless-planet'
  },
  REMOTE_LOG: {
    API_ENDPOINT: '/api/logging/remotelog'
  },
  ROUTES: {
    ADD_BILLING: 'AddBilling',
    ADD_CARD: 'AddCard',
    ADD_SHIPPING: 'AddShipping',
    CARD_DETAILS: 'CardDetails',
    COMING_SOON: 'ComingSoon',
    CONFIRM: 'Confirm',
    CONNECTION_SETTINGS: 'ConnectionSettings',
    CVC: 'CVC',
    FAQ: 'FAQ',
    EMAIL_CONFIRMATION: 'EmailConfirmation',
    ENTRY: 'Entry',
    ERROR: 'Error',
    SUPPORT: 'Support',
    LANGUAGE: 'Language',
    LIST_CARDS: 'ListCards',
    LIST_CARDS_UNPROVISIONED: 'ListCardsUnprovisioned',
    LIST_SHIPPING: 'ListShipping',
    LOGIN: 'Login',
    CONTACT_INFORMATION_SETTINGS: 'ContactInformationSettings',
    CONTACT_INFORMATION_SUPPORT: 'ContactInformationSupport',
    PROCESSING: 'Processing',
    PROFILE_CREATION: 'ProfileCreation',
    PROFILE_HOME: 'ProfileHome',
    PROFILE_SETTINGS: 'ProfileSettings',
    REACCEPTANCE: 'Reacceptance',
    REGISTER: 'Register',
    REGISTER_BILLING: 'RegisterBilling',
    REGISTER_TERMS: 'RegisterTerms',
    REVIEW_PROVISION: 'ReviewProvision',
    SETTINGS: 'Settings',
    THEME_SETTINGS: 'ThemeSettings',
    UNAVAILABLE: 'Unavailable',
    VERIFY_ACCOUNT: 'VerifyAccount',
    VERIFY_ISSUER: 'MdesChallenge',
    VERIFY_ISSUER_CHALLENGE: 'ThreeDsChallenge',
    VERIFY_MOBILE: 'VerifyMobile',
    VERIFY_OPTIONS: 'MdesMethodSelect'
  },
  TOTAL_STEPS: 3,
  TERMS_URL_FRENCH_CANADA:
    'https://www.mastercard.com/global/cliquer-pour-payer/fr-ca/terms-of-use.html',
  TEST_OVERRIDES: {
    GOOGLE_AUTOCOMPLETE: 'GOOGLE_AUTOCOMPLETE',
    ONE_TRUST: 'ONE_TRUST'
  },
  TNC_PRIVACY_DEFAULT_LOCALE: 'en-us',
  VALIDATION: {
    ABORT_CODE: 'ECONNABORTED',
    TIMEOUT: 60000
  },
  VALIDATION_CHANNEL: {
    EMAIL: 'EMAIL',
    ISSUER: 'ISSUER',
    PUSH: 'PUSH',
    SMS: 'SMS'
  }
}
